export const environment = {
  expressUrl: 'https://app-api.kalpasolutions.com',
  // tinyMceKey: 'c1j204m3d6brn3mq5ac394kuv0gptw5fv0wawyscbjwynhya',
  production: true,
  hmr: false,
  amplify: {
    Auth: {
      region: 'us-east-2',
      userPoolId: 'us-east-2_JUJ5Vwqrb',
      userPoolWebClientId: 'aicsii98i6bh3sqks5bef7cpp',
      identityPoolId: 'us-east-2:23d7073a-132b-44de-ac63-e2981951ae47',
    },
  },
  googleClientId: '903559517820-3jt9mvbfh07aku5g53biira8vimsh2lh.apps.googleusercontent.com',
  features: {
    courseBatchDuplicate: true,
  },
  sso: {
    response_type: 'code',
    scope: 'aws.cognito.signin.user.admin email openid phone profile',
    redirectUri: 'https://app.kalpasolutions.com/sso-callback',
    cognitoDomain: 'https://wvv8l6x950mz-production.auth.us-east-2.amazoncognito.com',
    clientId: '7k2p45sd05cg7aik755a79su0j',
  },
};
